export default {
  name: 'app',
  data: function() {
    return {
      clickCounter: 0,
      languagesToggle: false,
      langSelected: '',
      flag: '',
      isActive: true
    }
  },
  watch: {
    $route: function() {
      window.scrollTo(0, 0)
    }
  },
  computed: {
    languages: function() {
      return this.$store.getters.languages
    },
    languagesName: function() {
      return this.$store.getters.langFile.languages
    }
  },
  methods: {
    getFlag: function(lang) {
      lang = lang != undefined ? lang : this.$route.params.id
      return '../static/flags/' + lang + '.png'
    },
    goTo: function(route) {
      this.$store.commit('changeName', 'entry-component')
      this.$store.commit('changeColor', true)
      this.$store.commit('changeConnectNow', true)
      this.$router.push({
        name: route,
        params: {
          id: this.$route.params.id
        }
      })
    },
    displayLanguageSelection: function() {
      this.languagesToggle = !this.languagesToggle
      if (this.languagesToggle) this.clickCounter = 0
    },
    hideLanguageList: function() {
      if (this.languagesToggle && this.clickCounter > 0) {
        this.clickCounter = 0
        this.languagesToggle = false
      } else this.clickCounter++
    },
    translate: function(lang) {
      let oldRoute = this.$route.name === 'home' ? 'landing' : this.$route.name
      this.languagesToggle = !this.languagesToggle
      this.langSelected = lang
      this.flag = '../static/flags/' + this.id + '.png'
      this.$router.push({
        name: oldRoute,
        params: {
          id: this.langSelected
        }
      })
    }
  },
  mounted: function() {
    this.flag = '../static/flags/' + this.$route.params.id + '.png'
    this.isActive = (this.$options.name === 'imprint' || this.$options.name === 'privacy')
    this.langSelected = this.$route.params.id
  }
}


// WEBPACK FOOTER //
// ./src/components/app-component/app.js